/** ZIP batches must download one PDF member, not the whole archive. */
export function buildLabelledCopyDownloadOptions({ sourceIsZip, activeJob, zipMember }) {
  if (!sourceIsZip) return {};
  const member = zipMember || activeJob?.fileName || activeJob?.label || '';
  return member ? { member } : {};
}

export function zipDownloadBlockedMessage() {
  return 'Select a classified document in the list first — downloads use that PDF inside the ZIP, not the whole archive.';
}
